import type { AppFacilities } from "common/components/types";
import { assert, defined } from "common/Support";

let materialAppFacilities: AppFacilities | undefined;

export function setAppFacilities(appFacilities: AppFacilities): void {
    assert(materialAppFacilities === undefined);
    materialAppFacilities = appFacilities;
}

export function setMockedAppFacilities(mockedAppFacilities: AppFacilities | undefined): void {
    materialAppFacilities = mockedAppFacilities;
}

export function getAppFacilitiesForMock(): AppFacilities | undefined {
    return materialAppFacilities;
}

export function getAppFacilities(): AppFacilities {
    return defined(materialAppFacilities);
}
